import { Factory } from 'fishery'
import * as faker from 'faker'
import * as fns from 'date-fns'
import { DME } from '../form-types'

export enum InsuranceStatus {
  Inactive,
  UnsupportedPlanType,
  InvalidInsuranceInformation,
  UnsupportedInsuranceMember,
  UnknownError,
  Active,
}

export interface CustomerInformationFormFactoryTransientParams {
  insuranceStatus: InsuranceStatus
}

const getMemberIdSuffix = (insuranceStatus: InsuranceStatus) => {
  switch (insuranceStatus) {
    case InsuranceStatus.Inactive:
      return 0
    case InsuranceStatus.UnsupportedPlanType:
      return 2
    case InsuranceStatus.InvalidInsuranceInformation:
      return 3
    case InsuranceStatus.UnsupportedInsuranceMember:
      return 4
    case InsuranceStatus.UnknownError:
      return 6
    default:
      return 9
  }
}

export default Factory.define<
  DME.CustomerInformationFormInputs,
  CustomerInformationFormFactoryTransientParams
>(({ transientParams: { insuranceStatus = InsuranceStatus.Active } }) => {
  const firstName = faker.name.firstName()
  const lastName = faker.name.lastName()
  const email = faker.internet.email(firstName, lastName, 'example.com')
  const birthDate = fns.format(fns.sub(new Date(), { years: 18 }), 'yyyy-MM-dd')
  const dueDate = fns.format(fns.add(new Date(), { months: 3 }), 'yyyy-MM-dd')

  return {
    birthDate,
    dueDate,
    email,
    firstName,
    lastName,
    memberId: `BBLABC${email}-${getMemberIdSuffix(insuranceStatus)}`,
    phoneNumber: faker.phone.phoneNumber('(###) ###-####'),
    smsAllowed: false,
  }
})
